var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shipped",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 60.726,
    viewBox: "0 0 96 60.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M89.28,119.806l-2.486-9.944a1.5,1.5,0,0,0,1.19-1.47v-1.6a6.32,6.32,0,0,0-6.313-6.313H70.347V97.169a3.11,3.11,0,0,0-3.107-3.107H9.52a3.11,3.11,0,0,0-3.107,3.107v27.257a1.5,1.5,0,1,0,3.006,0V97.169a.1.1,0,0,1,.1-.1H67.24a.1.1,0,0,1,.1.1v27.257a1.5,1.5,0,1,0,3.006,0v-1.7h17.74a4.919,4.919,0,0,1,4.671,3.407H88.083a1.5,1.5,0,0,0-1.5,1.5v3.207a4.715,4.715,0,0,0,4.71,4.71h1.7v6.614h-3.93a9.517,9.517,0,0,0-17.993,0h-.724V130.839a1.5,1.5,0,1,0-3.006,0v11.323H36.153a9.517,9.517,0,0,0-17.993,0H9.52a.1.1,0,0,1-.1-.1v-3.307h6.514a1.5,1.5,0,1,0,0-3.006H1.5a1.5,1.5,0,1,0,0,3.006h4.91v3.307a3.11,3.11,0,0,0,3.107,3.107h8.12c0,.033,0,.067,0,.1a9.52,9.52,0,1,0,19.04,0c0-.034,0-.067,0-.1H70.549c0,.033,0,.067,0,.1a9.52,9.52,0,1,0,19.04,0c0-.034,0-.067,0-.1H94.5a1.5,1.5,0,0,0,1.5-1.5V127.632A7.928,7.928,0,0,0,89.28,119.806ZM70.347,103.482H81.67a3.311,3.311,0,0,1,3.307,3.307v.1H70.347Zm0,16.234V109.9H83.7l2.455,9.821Zm-43.19,32.067a6.514,6.514,0,1,1,6.514-6.514A6.521,6.521,0,0,1,27.157,151.782Zm52.91,0a6.514,6.514,0,1,1,6.514-6.514A6.521,6.521,0,0,1,80.067,151.782Zm12.927-19.24h-1.7a1.706,1.706,0,0,1-1.7-1.7v-1.7h3.407v3.407Z",
    transform: "translate(0 -94.062)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(23.814 46.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M131.814,350.6a3.547,3.547,0,1,0,3.547,3.547A3.55,3.55,0,0,0,131.814,350.6Z",
    transform: "translate(-128.267 -350.597)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(74.263 46.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8547",
    "data-name": "Path 8547",
    d: "M414,350.6a3.547,3.547,0,1,0,3.547,3.547A3.55,3.55,0,0,0,414,350.6Z",
    transform: "translate(-410.455 -350.597)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    transform: "translate(36.513 41.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8548",
    "data-name": "Path 8548",
    d: "M232.57,316.393H206.943a1.716,1.716,0,1,0,0,3.432H232.57a1.716,1.716,0,1,0,0-3.432Z",
    transform: "translate(-205.227 -316.393)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    transform: "translate(3.661 35.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8549",
    "data-name": "Path 8549",
    d: "M40.784,282.188H18.818a1.716,1.716,0,1,0,0,3.432H40.784a1.716,1.716,0,1,0,0-3.432Z",
    transform: "translate(-17.102 -282.188)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090",
    transform: "translate(25.864 13.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8550",
    "data-name": "Path 8550",
    d: "M173.926,171.525a1.716,1.716,0,0,0-2.427,0l-15.261,15.261-7.939-7.939a1.716,1.716,0,1,0-2.427,2.427l9.152,9.152a1.716,1.716,0,0,0,2.427,0l16.474-16.474A1.716,1.716,0,0,0,173.926,171.525Z",
    transform: "translate(-145.37 -171.023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.46138abd0ebf91a7f8fdbd1b6c2bf2d7.svg";
export { ForwardRef as ReactComponent };